export enum ElementStates {
  Default = "default",
  Changing = "changing",
  Modified = "modified",
}
